import type { RoadSection } from '../domain/Reference';

export type Neighbors = { previous: RoadSection | null; next: RoadSection | null };

export const NO_NEIGHBORS: Neighbors = { previous: null, next: null };

// The sections right before and after `current` along its axis (same road name), in cumul order.
export const neighborSections = (sections: RoadSection[], current: RoadSection): Neighbors => {
    const axis = sections
        .filter((section) => section.roadName === current.roadName)
        .sort((a, b) => a.cumulStart - b.cumulStart);
    const index = axis.findIndex((section) => section.id === current.id);
    if (index < 0) {
        return NO_NEIGHBORS;
    }

    return { previous: axis[index - 1] ?? null, next: axis[index + 1] ?? null };
};
